import { gql } from "@apollo/client";

export const GET_CALL_PLAN_DETAIL_QUERY = gql`
  query GetCallPlanDetail($callPlanId: Int!) {
    callPlan(id: $callPlanId) {
      id
      programWeek
      startDate
      endDate
      isActive
      program {
        id
        round
        program_type
        start_date
        end_date
      }
      interactions {
        id
        order
        skippable
        ... on OtherInteraction {
          type
          contentText
        }
        ... on ActivityInteraction {
          activityId
          title
          description
          estimatedDuration
          contents {
            id
            sequenceOrder
            readableText
            ... on QuestionActivityContent {
              questionTypeLabel
              responseTimeLimitSec
              silenceBeforeResponseSec
              expectedAnswers {
                id
                expectedAnswerText
              }
            }
          }
          voiceMessage {
            id
            audioFile {
              durationInSeconds
            }
            recordedBy {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
